export default __webpack_public_path__ + "static/media/Bedroom_V.3.9aeb16e6.png";